import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel, CarouselContent, CarouselSlot, Image } from '@yonderland/andes-react';
import Fade from 'embla-carousel-fade';
import { getImageFromCdn } from '../../util/ImageUtil';
export const GiftVoucherMainSlider = ({ images, imageCdnPrefix, setApi }) => {
    const renderSlide = (slide, index) => {
        const imagePath = getImageFromCdn(slide, imageCdnPrefix, '1024');
        return (_jsx(CarouselSlot, { children: _jsx(Image, { source: imagePath, alt: `gift_voucher_main_${index}` }) }, `gift_voucher_main_${index}`));
    };
    return (_jsx(Carousel, { testId: "gift_voucher_main_slider", slideSize: "100%", slideHeight: "auto", hideOverflow: true, setApi: setApi, plugins: [Fade()], children: _jsx(CarouselContent, { children: images.map(renderSlide) }) }));
};
